var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolarPanels(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.241,
    height: 36.434,
    viewBox: "0 0 43.241 36.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1461",
    "data-name": "Trac\\xE9 1461",
    d: "M64.251-43.589,47.212-74.827a.71.71,0,0,0-.623-.37H26.71a.737.737,0,0,0-.158.021h-.017a.687.687,0,0,0-.2.087.535.535,0,0,0-.051.038.743.743,0,0,0-.153.157c-.01.015-.023.027-.033.043a.616.616,0,0,0-.038.089.574.574,0,0,0-.025.057.709.709,0,0,0-.035.213v4.975a.712.712,0,0,0,.085.338l14.2,26.268a.71.71,0,0,0,.625.372H63.627a.71.71,0,0,0,.71-.71A.71.71,0,0,0,64.251-43.589Zm-6.079-8.179H53.4l-3.485-6.39h4.772ZM41.132-59.578H35.651l-3.485-6.39h5.482Zm-1.867-6.39h4.772l3.485,6.39H42.75Zm2.642,7.809,3.485,6.39H39.91l-3.485-6.39Zm1.618,0H48.3l3.485,6.39H47.01Zm10.387-1.42H49.14l-3.485-6.39h4.772Zm-7.745-14.2,3.485,6.39H44.88l-3.485-6.39Zm-6.39,0,3.485,6.39H38.491l-3.485-6.39Zm-6.39,0,3.485,6.39H31.391l-3.485-6.39Zm7.947,29.818L27.42-69.7V-71.7L42.552-43.959Zm2.836,0-3.485-6.39h5.482l3.485,6.39Zm7.1,0-3.485-6.39h4.772l3.485,6.39Zm6.39,0-3.485-6.39h4.772l3.485,6.39Z",
    transform: "translate(-26.003 75.197)",
    fill: "#e1f4fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1460",
    "data-name": "Trac\\xE9 1460",
    d: "M-937,95.243h803.932V-2067H-937Z",
    transform: "translate(937 2067)",
    fill: "#e1f4fb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2928",
    "data-name": "Groupe 2928",
    transform: "translate(-159.836 -771.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2927",
    "data-name": "Groupe 2927",
    transform: "translate(159.836 775)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2926",
    "data-name": "Groupe 2926",
    transform: "translate(-537.632 -1111.997)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1459",
    "data-name": "Trac\\xE9 1459",
    d: "M25-76.2H64.454v33.774H25Z",
    transform: "translate(512.07 1187.635)",
    fill: "#e1f4fb"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M9.771,5.857A.331.331,0,0,0,9.484,5.7H5.174L5.9.354A.32.32,0,0,0,5.678.018.337.337,0,0,0,5.29.146L.049,9.031a.309.309,0,0,0-.007.322.331.331,0,0,0,.287.163H4.575L4,14.866a.32.32,0,0,0,.226.328.337.337,0,0,0,.384-.132L9.767,6.178a.309.309,0,0,0,0-.321Z",
    transform: "translate(193.264 771.224)",
    fill: "#00a3da"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPanels);
export default __webpack_public_path__ + "static/media/solar-panels.bac5074cdbb7ce1b838a49678bf99334.svg";
export { ForwardRef as ReactComponent };